import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav >
      <ul style={{ display: "flex", gap: "40px", backgroundColor:"black",  padding:"30px" ,color:"white"}}>
        <li ><Link to="/" style={{textDecoration:"none", color:"white"}}>Client Data</Link></li>
        <li><Link to="/uploadexcel" style={{textDecoration:"none" , color:"white"}}>Upload Excel</Link></li>
        <li> <Link to="/labels" style={{textDecoration:"none" , color:"white"}}>Labels</Link></li>
        <li> <Link to="/labelslist" style={{textDecoration:"none" , color:"white"}}>Labels List</Link></li>

      </ul>
    </nav>
  );
}

export default Navbar;
